import {AlertIcon, CommentIcon, FileIcon} from '@primer/octicons-react'
import {CollapsiblePanel} from './CollapsiblePanel'
import {ExpandableContent} from './ExpandableContent'
import styles from './ChangeSummary.module.css'
import type {ChangeSummary} from '../../routes/route-payload-types'

type OverviewChangeHighlightsProps = {
  changeHighlights: ChangeSummary[] | null
}

/** Change summary section listing grouped changes */
export function ChangeSummary({changeHighlights}: OverviewChangeHighlightsProps) {
  const showChangeHighlights = changeHighlights && changeHighlights.length > 0
  return showChangeHighlights ? (
    <CollapsiblePanel heading="Change summary">
      <ExpandableContent sectionLabel="Change summary">
        <div className={styles.list}>
          {changeHighlights &&
            changeHighlights.map((highlight, index) => (
              <OverviewSummaryItem
                key={index}
                number={index + 1}
                title={highlight.name}
                description=""
                files={highlight.fileSummaries.map(file => ({
                  path: file.path,
                  additions: file.additions,
                  deletions: file.deletions,
                }))}
              />
            ))}
        </div>
      </ExpandableContent>
    </CollapsiblePanel>
  ) : null
}

interface FileEntry {
  path: string
  additions: number
  deletions: number
  warnings?: string
  comments?: string
}

interface OverviewSummaryItemProps {
  number: number
  title: string
  description: string
  files: FileEntry[]
}

function OverviewSummaryItem({number, title, description, files}: OverviewSummaryItemProps) {
  return (
    <div className={styles.itemContainer}>
      <div className={styles.itemHeader}>
        <span className={styles.itemNumber}>{number}</span>
        <h4 className={styles.itemTitle}>{title}</h4>
      </div>
      <p className={styles.itemDescription}>{description}</p>
      <div className={styles.fileList}>
        {files.map(file => (
          <FileRow key={file.path} file={file} />
        ))}
      </div>
    </div>
  )
}

function FileRow({file}: {file: FileEntry}) {
  return (
    <div className={styles.fileRow}>
      <span className={styles.fileInfo}>
        <FileIcon size={16} className={styles.fileIcon} />
        <span className={styles.fileName}>{file.path}</span>
        <span className={styles.additions}>+{file.additions}</span>
        <span className={styles.deletions}>-{file.deletions}</span>
      </span>
      <span className={styles.countGroup}>
        {file.warnings && (
          <span className={styles.countItem}>
            <AlertIcon size={16} />
            {file.warnings}
          </span>
        )}
        {file.comments && (
          <span className={styles.countItem}>
            <CommentIcon size={16} />
            {file.comments}
          </span>
        )}
      </span>
    </div>
  )
}
